import {
    ComponentFactoryResolver, ComponentRef,
    Injectable, Injector, ViewContainerRef
} from '@angular/core';

import { ConfirmationDialogComponent, DataCollectingConfirmationDialogComponent, DIALOG_TOKEN } from '@shared/*';
import { ConfType } from '@models/*';

@Injectable({
    providedIn: 'root'
})
export class ComponentGeneratorService {

    private generatedComponentRef: ComponentRef<ConfirmationDialogComponent | DataCollectingConfirmationDialogComponent>;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private injector: Injector
    ) {
    }

    public generateConfirmationDialog(insertionRef: ViewContainerRef, type: ConfType, extras?: { [k: string]: any }) {
        const componentFactory = (type === ConfType.START_SHIFT || type === ConfType.END_SHIFT) ?
            this.componentFactoryResolver.resolveComponentFactory(DataCollectingConfirmationDialogComponent) :
            this.componentFactoryResolver.resolveComponentFactory(ConfirmationDialogComponent);

        const newInjector = Injector.create({
            providers: [
                {
                    provide: DIALOG_TOKEN,
                    useValue: {
                        insertionRef,
                        insertionIndex: insertionRef.length,
                        type,
                        extras
                    }
                }
            ],
            parent: this.injector
        });

        this.generatedComponentRef = insertionRef.createComponent(<any>componentFactory, undefined, newInjector);
    }
}
